import { gql } from '@apollo/client';
import eventFieldsFragment from './eventFragment';
import atlSponsorRankingsFragment from './atlSponsorRankingsFragment';
import userCommentAccessibilityOptionsFragment from './userCommentAccessibilityOptionsFragment';

const GET_EVENT_BY_ID = gql`
  query GetEventById($id: Int!) {
    appraiserEvent(id: $id) {
      ...EventFields
      AtlSponsorRankings {
        ...AtlSponsorRankingsFields
      }
      UserCommentAccessibilityOptions {
        ...UserCommentAccessibilityOptionsFields
      }
      SowContractTypes {
        Title
        Value
      }
      AtmRoleOptions {
        Title
        Value
      }
    }
  }

  ${userCommentAccessibilityOptionsFragment}
  ${eventFieldsFragment}
  ${atlSponsorRankingsFragment}
`;

export default GET_EVENT_BY_ID;
